"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findCoverDesign = exports.findMatchingOrDefaultDesign = exports.getAllowedDesigns = exports.getLayersForDesign = exports.isDesignAllowedForPrintableIdx = exports.isDesignAllowedForPageCount = exports.getCoverDesignOptions = exports.getBookInteriorDesignOptions = exports.getBookInteriorDesign = void 0;
exports.findLayersInTemplate = findLayersInTemplate;
/* eslint-disable @typescript-eslint/ban-ts-comment */
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const either_1 = require("../../types/either");
const Design_1 = require("../../models/Design");
const layers_1 = require("../layers");
const isDesignAllowedForPageCount_1 = __importDefault(require("./isDesignAllowedForPageCount"));
const constants_1 = require("./constants");
const isDesignAllowedForPages_1 = __importDefault(require("./isDesignAllowedForPages"));
var getBookInteriorDesign_1 = require("./getBookInteriorDesign");
Object.defineProperty(exports, "getBookInteriorDesign", {
  enumerable: true,
  get: function () {
    return __importDefault(getBookInteriorDesign_1).default;
  }
});
var getBookInteriorDesignOptions_1 = require("./getBookInteriorDesignOptions");
Object.defineProperty(exports, "getBookInteriorDesignOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(getBookInteriorDesignOptions_1).default;
  }
});
var getCoverDesignOptions_1 = require("./getCoverDesignOptions");
Object.defineProperty(exports, "getCoverDesignOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(getCoverDesignOptions_1).default;
  }
});
var isDesignAllowedForPageCount_2 = require("./isDesignAllowedForPageCount");
Object.defineProperty(exports, "isDesignAllowedForPageCount", {
  enumerable: true,
  get: function () {
    return __importDefault(isDesignAllowedForPageCount_2).default;
  }
});
var isDesignAllowedForPrintableIdx_1 = require("./isDesignAllowedForPrintableIdx");
Object.defineProperty(exports, "isDesignAllowedForPrintableIdx", {
  enumerable: true,
  get: function () {
    return __importDefault(isDesignAllowedForPrintableIdx_1).default;
  }
});
const getLayersForDesign = (sku, template, design1, design2) => {
  const findLayersInTemplateResult = findLayersInTemplate(template, design1);
  if (findLayersInTemplateResult.isLeft()) {
    return (0, either_1.left)(findLayersInTemplateResult.value);
  }
  if (design2) {
    const findLayersInTemplateResult2 = findLayersInTemplate(template, design2);
    if (findLayersInTemplateResult2.isLeft()) {
      return (0, either_1.left)(findLayersInTemplateResult2.value);
    }
    const shiftedLayers = (0, layers_1.shiftDesignLayersRight)(sku, findLayersInTemplateResult2.value, template.surface);
    const compositeLayers = [...findLayersInTemplateResult.value, ...shiftedLayers];
    return (0, either_1.right)(compositeLayers);
  } else {
    return (0, either_1.right)(findLayersInTemplateResult.value);
  }
};
exports.getLayersForDesign = getLayersForDesign;
function findLayersInTemplate(template, design) {
  const layers = design.layers.map(lid => {
    const layer = template.layers.find(l => l.id === lid);
    if (!layer) {
      return (0, either_1.left)(new Error(`Layer not found: ${lid}`));
    }
    return (0, either_1.right)(Object.assign({}, layer));
  });
  const {
    lefts,
    rights
  } = (0, either_1.splitArray)(layers);
  if (lefts.length > 0) {
    return (0, either_1.left)(new Error(lefts.map(e => e.message).join('\n')));
  }
  return (0, either_1.right)(rights);
}
const getAllowedDesigns = _ref => {
  let {
    allowedPages,
    interiorPageCount,
    designs,
    coverage
  } = _ref;
  const designsAllowedByPageCountAndPages = designs.filter(design => {
    return (0, isDesignAllowedForPageCount_1.default)(design, interiorPageCount) && (0, isDesignAllowedForPages_1.default)(design, allowedPages);
  });
  if (!designsAllowedByPageCountAndPages.length) {
    return (0, either_1.left)(new Error(`No design found in allowedPageCount range for ${interiorPageCount} interior printables and allowedPages: "${allowedPages}"`));
  }
  const designsWithMatchingCoverage = designsAllowedByPageCountAndPages.filter(design => design.coverage === coverage);
  if (!designsWithMatchingCoverage.length) {
    return (0, either_1.left)(new Error(`No design found within allowedPageCount range for interiorPageCount: ${interiorPageCount}, allowedPages: "${allowedPages}" with matching coverage: "${coverage}"`));
  }
  return (0, either_1.right)(designsWithMatchingCoverage);
};
exports.getAllowedDesigns = getAllowedDesigns;
const findMatchingOrDefaultDesign = _ref2 => {
  let {
    newTemplateDesigns,
    oldTemplateDesigns,
    designId,
    interiorPageCount
  } = _ref2;
  const oldDesign = oldTemplateDesigns === null || oldTemplateDesigns === void 0 ? void 0 : oldTemplateDesigns.find(design => design.id === designId);
  const {
    allowedPages,
    coverage
  } = oldDesign || {};
  let allowedDesigns;
  // Account for restrictions
  if (interiorPageCount && allowedPages) {
    const allowedDesignsResult = (0, exports.getAllowedDesigns)({
      allowedPages,
      interiorPageCount,
      designs: newTemplateDesigns,
      coverage
    });
    if (allowedDesignsResult.isLeft()) {
      return (0, either_1.left)(allowedDesignsResult.value);
    }
    allowedDesigns = allowedDesignsResult.value;
  } else {
    allowedDesigns = newTemplateDesigns;
  }
  const newDesign = allowedDesigns.find(design => design.id === designId) || allowedDesigns.find(design => design.default) || allowedDesigns[0];
  if (!newDesign) {
    return (0, either_1.left)(new Error(`no matching, default, or allowed design found for designId: ${designId}, interiorPageCount: ${interiorPageCount}`));
  }
  return (0, either_1.right)((0, lodash_clonedeep_1.default)(newDesign));
};
exports.findMatchingOrDefaultDesign = findMatchingOrDefaultDesign;
const findCoverDesign = (templateDesigns, interiorPrintableCount, designId) => {
  const coverDesigns = templateDesigns.filter(d => {
    const isFirstPageDesign = d.allowedPages === constants_1.FIRST;
    return isFirstPageDesign && (0, isDesignAllowedForPageCount_1.default)(d, interiorPrintableCount);
  });
  // If a designId was provided, look for a design with that ID. Otherwise look for the design marked as default
  let design = coverDesigns.find(design => designId ? design.id === designId : design.default);
  if (!design) {
    design = coverDesigns[0];
  }
  if (!(0, Design_1.isDesign)(design)) {
    return (0, either_1.left)(new Error('findCoverDesign: No design found in template'));
  }
  return (0, either_1.right)((0, lodash_clonedeep_1.default)(design));
};
exports.findCoverDesign = findCoverDesign;